// extracted by mini-css-extract-plugin
export default {"pageWrap":"Se-z","fullWidth":"Te-z","heading":"Ue-z","fullBleed":"Ve-z","hidden":"We-z"};